import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"รับบุตรบุญธรรม (Adoption) — คนไทย/ต่างชาติ + Hague Convention 1993","metaTitle":"รับบุตรบุญธรรม — ทนายจัดเตรียมคำร้อง กรมกิจการเด็ก | NYC","metaDesc":"รับบุตรบุญธรรมคนไทย ต่างชาติ Hague Convention 1993 ผ่าน กรมกิจการเด็กและเยาวชน ระยะเวลา 6-18 เดือน ทนายดูแลทุกขั้นตอน"},"en":{"h1":"Adoption — Domestic & Intercountry under Hague 1993","metaTitle":"Thailand Adoption — Domestic & Hague 1993 Intercountry | NYC","metaDesc":"Adoption filings via DCY (Department of Children and Youth). Domestic Thai adoption and Hague 1993 in — Get your timeline and checklist in minutes — chat now."}} as const;

export const Route = createFileRoute("/en/family/adoption")({
  head: () => {
    const url = `${SEO_SITE}/en/family/adoption`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/family/adoption", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/family/adoption", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/family/adoption", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/family/adoption", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/family/adoption", "/en/family/adoption")],
    };
  },
  component: () => <SubServicePage slug="family/adoption" locale="en" />,
});
